export enum RawTransactionStatus {
  PENDING = 'PENDING',
  MATCHED_AUTO = 'MATCHED_AUTO',
  MATCHED_MANUAL = 'MATCHED_MANUAL',
  IGNORED = 'IGNORED',
}

export enum TransactionDirection {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING',
}
